import script from "./MembershipBenefitsBrands.vue?vue&type=script&lang=ts&setup=true"
export * from "./MembershipBenefitsBrands.vue?vue&type=script&lang=ts&setup=true"

import "./MembershipBenefitsBrands.vue?vue&type=style&index=0&id=e11aee60&lang=css"

const __exports__ = script;

export default __exports__